/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Switch, message, Spin } from "antd";
import axios from "axios";
import {
  CREATE_CONNECTION,
  GET_AUTHENTICATION,
  GET_CONNECTION,
  UPDATE_CONNECTION,
} from "../../util";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";

const Credentials = ({
  setConnections,
  editConnection,
  setConnectionId,
  resetForms,
  setResetForms,
  onClose,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(true);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (editConnection) {
      console.log("editConnection data:", JSON.stringify(editConnection, null, 2));
      console.log("Token data:", editConnection?.Token);
      
      // Try multiple possible data structures
      const formData = {
        connectionName: editConnection?.connectionName,
        accountNo: editConnection?.Token?.accountNo || editConnection?.accountNo || editConnection?.Token?.userName,
        userName: editConnection?.Token?.mintSoftUsername ,
        password: editConnection?.Token?.mintSoftPssword,
        myParcelApiKey: editConnection?.Token?.myParcelApiKey || editConnection?.myParcelApiKey,
        status: editConnection.status,
      };
      
      console.log("Setting form values:", formData);
      form.setFieldsValue(formData);
      setIsActive(editConnection.status);
    } else {
      console.log("else - resetting form");
      form.resetFields();
      setIsActive(true);
    }
  }, [editConnection, form]);

  const onChange = (checked) => {
    setIsActive(checked);
  };

  const onFinish = (values) => {
    localStorage.setItem("formValues", JSON.stringify(values));
    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigate("/");
    }
    const endpoint = editConnection
      ? `${UPDATE_CONNECTION}/${editConnection.id}`
      : CREATE_CONNECTION;
    const method = editConnection ? "put" : "post";

    setLoader(true);
    axios[method](endpoint, {
      ...values,
      ...(editConnection && { status: isActive }),
      ...(editConnection && { id: editConnection.id }),
    })
      .then((response) => {
        onClose();
        if (response.status === 200) {
          if (editConnection) {
            setConnections((prevConnections) => {
              if (!Array.isArray(prevConnections)) {
                prevConnections = [];
              }

              if (editConnection) {
                return prevConnections.map((connection) =>
                  connection.id === editConnection.id
                    ? response.data
                    : connection
                );
              } else {
                return [...prevConnections, response.data.data];
              }
            });
          }
          message.success(
            editConnection
              ? "Update connection successful!"
              : "Create connection successful!"
          );

          // Make the second API call
          console.log(
            "Making second API call",
            response.data,
            response.data.length
          );
          if (response.data.length > 0) {
            const lastItemId = response.data[response.data.length - 1];
            console.log(
              "lastItemId: " +
              JSON.stringify(response.data[response.data.length - 1].id)
            );
            if (!editConnection) {
              axios
                .post(`${GET_AUTHENTICATION}`, { id: lastItemId.id })
                .then((response) => {
                  // Handle response here
                  if (response?.data?.success) {
                    axios.post(`${GET_CONNECTION}`).then((resp) => {
                      setConnections(resp.data);
                    });
                    message.success(response?.data?.message);
                  } else {
                    return message.error(response?.data?.message);
                  }
                })
                .catch((error) => {
                  // Handle error here
                  console.error("API Call Failed:", error);
                });
            }
          } else {
            console.log("No data available to make API call.");
          }
        } else {
          message.error("Wrong credentials!");
          return Promise.reject("Wrong credentials!");
        }
      })

      .catch((err) => {
        console.error("Error occurred:", err);
        message.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoader(false);
        onClose();
      });
  };

  useEffect(() => {
    console.log("id");
    if (resetForms && editConnection == null) {
      console.log("id");

      form.resetFields();
      setIsActive(false);
      setResetForms(false); // Reset form state after reset
    }
  }, [resetForms, setResetForms, form]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        flexDirection: "column",
      }}
    >
      {loader && (
        <div className={styles.overlay}>
          <Spin size="large" />
        </div>
      )}
      <div>
        <Form
          name="basic"
          form={form}
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          {editConnection && (
            <Form.Item
              label="Active"
              name="status"
              valuePropName="checked"
              style={{ display: "flex", justifyContent: "end" }}
            >
              <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
                onChange={onChange}
                checked={isActive}
                style={{ backgroundColor: isActive ? "green" : undefined }}
              />
            </Form.Item>
          )}
          {/* </div> */}
          <Form.Item
            label="Connection Name"
            name="connectionName"
            rules={[
              { required: true, message: "Please input your Connection Name!" },
              {
                validator: (_, value) =>
                  value && value.length === 3
                    ? Promise.resolve()
                    : Promise.reject(
                      new Error(
                        "Connection Name must be exactly 3 characters!"
                      )
                    ),
              },
            ]}
          >
            <Input
              maxLength={3}
              onChange={(e) => {
                const { value } = e.target;
                form.setFieldsValue({ connectionName: value.toUpperCase() });
              }}
            />
          </Form.Item>

          <Form.Item
            label="Account Number"
            name="accountNo"
            rules={[
              { required: true, message: "Please input your Account Number!" }
            ]}
          >
            <Input placeholder="Enter Account Number" />
          </Form.Item>
          <Form.Item
            label="MintSoft UserName"
            name="userName"
            rules={[
              { required: true, message: "Please input your username!" }
            ]}
          >
            <Input placeholder="Enter MintSoft Username" />
          </Form.Item>
          <Form.Item
            label="MintSoft Password"
            name="password"
            rules={[
              { required: true, message: "Please input your password!" }
            ]}
          >
            <Input.Password placeholder="Enter MintSoft Password" />
          </Form.Item>
          <Form.Item
            label="MyParcel API Key"
            name="myParcelApiKey"
            rules={[
              {
                required: true,
                message: "Please input your MyParcel API Key!",
              }
            ]}
          >
            <Input />
          </Form.Item>


          <Form.Item>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <Button 
                type="default" 
                onClick={() => {
                  console.log("Current form values:", form.getFieldsValue());
                  console.log("EditConnection:", editConnection);
                }}
              >
                Debug Values
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Credentials;
